module.exports = __webpack_public_path__ + "img/kefu.4446478a.jpg";